export enum UserApiMessages {
  USER_UPDATED = 'User Updated Successfully',
}
